import React from 'react';
import { Box, Typography } from '@mui/material';
import FuncionarioTable from '../components/funcionario/FuncionarioTable';

const Funcionarios: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Funcionários
      </Typography>
      <FuncionarioTable />
    </Box>
  );
};

export default Funcionarios;
